export const SET_FINANCIAL_FACILITIES = 'SET_FINANCIAL_FACILITIES'
export const ADD_FINANCIAL_FACILITY = 'ADD_FINANCIAL_FACILITY'
export const UPDATE_FINANCIAL_FACILITY = 'UPDATE_FINANCIAL_FACILITY'

